import React from 'react';
import {useSelector} from 'react-redux';
import {createSelector} from 'reselect';
// import styled from 'styled-components';

// SELECTOR FNS
import {
  hotelAddressSelector as hotelAddressSelectorFn,
  hotelArea as hotelAreaSelectorFn,
  hotelCountrySelector as hotelCountrySelectorFn,
  hotelAreaPincodeSelector as hotelAreaPincodeSelectorFn,
} from '../../selectors';

// ICONS
// import LocationPin from '../../../../../stories/Icons/LocationIcon';

// CONFIG
// import {defaultTheme} from 'build-theme/src/build-theme';

import * as S from './HotelDetails.styles';

const hotelAddressSelector = createSelector(
  [hotelAddressSelectorFn, hotelAreaSelectorFn, hotelCountrySelectorFn, hotelAreaPincodeSelectorFn],
  (hotelAddressText, hotelArea, hotelCountry, hotelAreaPincode) => ({
    hotelAddressText,
    hotelArea,
    hotelCountry,
    hotelAreaPincode,
  }),
);

// const HotelAddressTextSpan = styled.span(
//   props => `
//   font-size:${props.theme.font.base};
//   color: ${props.theme.colors.grey.light9b};
//   display: flex;
//   align-items: center;
// `,
// );

// const HotelAddressStyled = styled.address(
//   props => `
//   font-style: inherit;
//   padding: 0 ${props.theme.spacing.small.s5};
// `,
// );

function HotelAddressText() {
  const {hotelAddressText, hotelArea, hotelCountry, hotelAreaPincode} = useSelector(
    hotelAddressSelector,
  );

  /** this piece of code is to prevent duplication of text
   * but if this is used to conditionally show hotelArea, hotelCountry, hotelPincode
   * then the schema.org attributes will be missed. Hence allowing duplication for now
   *
   * note: duplication was always there in old dweb implementation.
   */
  // const hotelAddressTextDoesNotIncludeHotelArea =
  //   hotelAddressText && !hotelAddressText.include(hotelArea);
  // const hotelAddressTextDoesNotIncludeHotelCountry =
  //   hotelAddressText && !hotelAddressText.include(hotelCountry);
  // const hotelAddressTextDoesNotIncludePinCode =
  //   hotelAddressText && !hotelAddressText.include(hotelAreaPincode);

  if (!(hotelAddressText || hotelArea || hotelCountry)) {
    return null;
  }

  return (
    <S.HotelAddresWrap>
      {!!hotelAddressText && <S.AddresText>{`${hotelAddressText}, `}</S.AddresText>}
      {!!hotelArea && <S.AddresText>{`${hotelArea}, `}</S.AddresText>}
      {!!hotelCountry && <S.AddresText>{`${hotelCountry}, `}</S.AddresText>}
      {!!hotelAreaPincode && <S.AddresText>{hotelAreaPincode}</S.AddresText>}
    </S.HotelAddresWrap>
    // <HotelAddressTextSpan itemScope itemProp="location" itemType="http://schema.org/Place">
    //   <LocationPin width="18px" height="18px" fill={defaultTheme.colors.grey.light9b} />

    //   <HotelAddressStyled itemScope itemProp="address" itemType="http://schema.org/PostalAddress">
    //     {!!hotelAddressText && <span itemProp="streetAddress">{`${hotelAddressText} `}</span>}

    //     {!!hotelArea && <span itemProp="addressRegion">{`${hotelArea} `}</span>}
    //     {!!hotelCountry && <span itemProp="addressCountry">{`${hotelCountry} `}</span>}
    //     {!!hotelAreaPincode && <span itemProp="postalCode">{hotelAreaPincode}</span>}
    //   </HotelAddressStyled>
    // </HotelAddressTextSpan>
  );
}

export default HotelAddressText;
